import { ShipmentDetails, ShippingPickupTypeEnum } from '@/external/timeline/interfaces/timeline';
import { Trans } from 'react-i18next';
import styles from './shipping.module.scss';

const langPrefix = 'MY_ACCOUNT.ORDERS_SALES.ACTION.GET_SHIPPING_LABEL.';
const classNamePath = 'shippingInfo';

interface ShippingInstructionDescriptionProps {
  shipmentDetails?: ShipmentDetails;
  carrierWebsite?: string;
}

const ShippingInstructionDescription = ({ shipmentDetails, carrierWebsite }: ShippingInstructionDescriptionProps) => {
  const { homeCollectionLink, homeCollectionPhoneNumber, dropOffMapAvailable, shippingOption } = shipmentDetails || {};

  // Drop-off description
  let dropOffDescription = `${langPrefix}SEE_NEAREST`;

  if (dropOffMapAvailable && carrierWebsite) {
    dropOffDescription = `${langPrefix}SEE_NEAREST_ONLINE`;
  }

  switch (shippingOption) {
    case ShippingPickupTypeEnum.dropOff: {
      if (!dropOffMapAvailable && !carrierWebsite) {
        return <></>;
      }

      return (
        <Trans
          i18nKey={dropOffDescription}
          components={{
            clickable: <button className={styles[`${classNamePath}__viewDropOff--link`]}>{''}</button>,
            a: carrierWebsite ? <button className={styles[`${classNamePath}__viewDropOff--link`]}>{''}</button> : <></>,
          }}
        />
      );
    }

    case ShippingPickupTypeEnum.homeCollection: {
      let descKey = 'HOME-LINK-PHONE';

      if (homeCollectionLink && !homeCollectionPhoneNumber) {
        descKey = 'HOME-LINK';
      } else if (!homeCollectionLink && homeCollectionPhoneNumber) {
        descKey = 'HOME-PHONE';
      } else if (!homeCollectionLink && !homeCollectionPhoneNumber) {
        descKey = 'HOME-NO-LINK-PHONE';
      }

      return (
        <div>
          <Trans
            i18nKey={`${langPrefix}${descKey}`}
            values={{
              phone: homeCollectionPhoneNumber || '',
            }}
            components={{
              a: <button className={styles[`${classNamePath}__viewDropOff--link`]}>{''}</button>,
            }}
          />
        </div>
      );
    }

    default:
      return <></>;
  }
};

export default ShippingInstructionDescription;
